// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IngredTable_wrapper__22RZf"};